<template>
    <div class="pm-sr-locator">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'Contact',
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue